import CancelDialog from './CancelDialog.vue';

export default CancelDialog;
